<template>

    <div class="banner" :style="styles" @click="openLink">
        <slot></slot>
    </div>

</template>

<style scoped lang="scss">

    .banner {
        @include font-medium(14px);
        color: #fff;
        cursor: pointer;
        line-height: 1.6em;
        padding: 15px;
        text-align: center;
        a {
            color: inherit;
        }
    }

</style>

<script>

export default {

    props: {
        color: {
            type: String,
            default: '#2EC76F',
        },
        link: {
            type: String,
            required: true,
        },
    },

    computed: {

        styles() {
            return {
                background: this.color,
            }
        },

    },

    methods: {

        openLink() {
            window.open(this.link, '_blank');
        },

    },

}

</script>
